import { Amplify } from "aws-amplify";
import { fetchConfig } from "../hooks/use-config";

export interface AmplifyAppConfig {
  signInIdentityProvider: string;
}

export async function configureAmplify(): Promise<AmplifyAppConfig> {
  const config = await fetchConfig();
  Amplify.configure({
    Auth: {
      userPoolId: config.userPoolId,
      userPoolWebClientId: config.clientId,
      oauth: {
        domain: config.domain,
        scope: [
          "openid",
          "profile",
          "aws.cognito.signin.user.admin",
          ...config.scopes,
        ],
        redirectSignIn: window.location.origin,
        redirectSignOut: window.location.origin,
        responseType: "code",
      },
    },
  });

  return { signInIdentityProvider: config.signInIdentityProvider };
}
